import { createTheme } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import muiTypographyStyles from '@styles/components/mui-typography-styles.ts';
import muiButtonStyles from '@styles/components/mui-button-styles.ts';
import muiInputStyles from '@styles/components/mui-input-styles.ts';
import muiStepperStyles from '@styles/components/mui-stepper-styles.ts';
import muiButtonGroupStyles from '@styles/components/mui-button-group-styles.ts';
import muiTabsStyles from '@styles/components/mui-tabs-styles.ts';
import muiTableStyles from '@styles/components/mui-table-styles.ts';
import muiPaginationStyles from '@styles/components/mui-pagination-styles.ts';
import muiCheckboxStyles from '@styles/components/mui-checkbox-styles.ts';
import muiMenuStyles from '@styles/components/mui-menu-styles.ts';
import muiChipStyles from '@styles/components/mui-chip-styles.ts';
import muiCircularProgressStyles from '@styles/components/mui-circular-progress-styles.ts';
import muiDialogStyles from '@styles/components/mui-dialog-styles.ts';
import muiSvgIconsStyles from '@styles/components/mui-svg-icon-styles.ts';
import muiTooltipStyles from '@styles/components/mui-tooltip-styles.ts';
import muiAccordionStyles from '@styles/components/mui-accardion-styles.ts';

const getCSSVariable = (variable: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(variable).trim();

const getTheme = (primaryColor?: string) => {
  const fallbackColor = getCSSVariable('--primary') || '#7136ED';
  const resolvedPrimary = primaryColor || fallbackColor;

  return createTheme({
    palette: {
      primary: { main: resolvedPrimary },
      secondary: purple
    },
    typography: muiTypographyStyles,
    components: {
      ...muiButtonStyles,
      ...muiInputStyles,
      ...muiStepperStyles,
      ...muiButtonGroupStyles,
      ...muiTabsStyles,
      ...muiTableStyles,
      ...muiPaginationStyles,
      ...muiCheckboxStyles,
      ...muiMenuStyles,
      ...muiSvgIconsStyles,
      ...muiDialogStyles,
      ...muiChipStyles,
      ...muiCircularProgressStyles,
      ...muiTooltipStyles,
      ...muiAccordionStyles
    }
  });
};

export default getTheme;
